import { Metamodel } from 'app/model/base/model';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { mongoDbDriverVersion } from 'app/shared/utils/connector-metadata-static-consts';

@Metamodel.model({
    name: adfModelTypeMap.mongoDbAtlas.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MongoDbAtlas_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.MongoDbAtlas_DisplayText)
    ]
})
export class MongoDbAtlasLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly CONNECTION_STRING: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly DRIVER_VERSION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ConnectionString,
        association: 'CONNECTION_STRING',
        accepts: ['String']
    })
    public connectionString: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME'
    })
    public databaseName: string;

    @Metamodel.attribute({
        display: stringResources.DriverVersion,
        association: 'DRIVER_VERSION'
    })
    public driverVersion: string = mongoDbDriverVersion.V2;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
